import { CustomScene } from '@App/app/entities/viewer/custom-scene.model';
import { PhotoDimensions } from '@App/app/entities/shared/parameters.model';
import { Angle, Axis, Mesh, MeshBuilder, Plane, Quaternion, Space, Vector3 } from 'babylonjs';
import { ENGINE_BACKGROUND } from '@App/app/configs/babylon.config';

export const buildPhotoPlane = (
  scene: CustomScene,
  name: string,
  dimensions: PhotoDimensions,
  position: Vector3,
  rotationQuaternion: Quaternion,
): Mesh => {
  const plane = new Plane(0, 1, 0, 0);
  const viewerPhoto = MeshBuilder.CreatePlane(
    name,
    {
      ...dimensions,
      sourcePlane: plane,
    },
    scene,
  );
  viewerPhoto.isPickable = true;
  viewerPhoto.enableEdgesRendering();
  viewerPhoto.edgesWidth = 1;
  viewerPhoto.edgesColor = ENGINE_BACKGROUND.color;
  viewerPhoto.renderingGroupId = 2;
  viewerPhoto.position = position.clone();
  viewerPhoto.rotationQuaternion = rotationQuaternion;
  viewerPhoto.rotate(Axis.Y, Angle.FromDegrees(180).radians(), Space.LOCAL);
  viewerPhoto.rotate(Axis.Z, -(viewerPhoto.rotationQuaternion.toEulerAngles().z * 2), Space.LOCAL);
  return viewerPhoto;
};
